import { createMfeTestpageApp } from '@common/testpage/MfeTestpageApp.js';
import { projectConfig } from '@root/projectConfig.js';

declare let IS_DEV: boolean;
const app = createMfeTestpageApp({
  apiEndpoint: 'api-4p',
  isDev: IS_DEV,
  port: projectConfig.port,
  tag: 'tef-coms4p',
});
app.mount('body');
